export const nameExp =  "^[a-zA-Z ]*[a-zA-Z]$";
export const numberExp =  "^[0-9]+$";
export const alphabetExp =  "^[a-zA-Z ]+$";
export const emailExp = "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$";
export const alphaNumericExp = "^[a-zA-Z0-9]+$";
export const alphaNumericSpaceExp = "^[a-zA-Z0-9 ]+$";
export const gradeMarksExp = "^[a-zA-Z0-9*+]+$";
